module.exports = __webpack_public_path__ + "static/feature_4-88c9272c7a375cb9d69db5c0606452a0.svg";